import React, { useState } from 'react';
import './home-categories.css';
import Common_title from '../../common-components/common-title/Common_title';
import { Link } from 'react-router-dom';

const Categories = () => {
    const allcategory = [
        { catname: "Clothing", catimg: "/assets/images/home/category/cat11.avif" },
        { catname: "Footwear", catimg: "/assets/images/home/category/cat2.avif" },
        { catname: "Accessories", catimg: "/assets/images/home/category/cat3.avif" },
        { catname: "T-shirt", catimg: "/assets/images/home/category/cat4.avif" },
        { catname: "Electronics", catimg: "/assets/images/home/category/cat5.jpg" },
    ];

    const [showAll, setShowAll] = useState(false);

    const displayedCategories = showAll ? allcategory : allcategory.slice(0, 5);

    return (
        <section className='home_categories_sec'>
            <div className='container'>
                <Common_title title="Category" subtitle="What we’re offering to customers" />
                <div className='all-category'>
                    <div className="grid-row">
                        {displayedCategories.map((data, index) => (
                            <div className="grid-col" key={index}>
                                <Link target="_blank" to="https://play.google.com/store/apps/" >
                                    <div className='cat_div'>
                                        <div className='img_div'>
                                            <img className='catimg' src={process.env.PUBLIC_URL + data.catimg} alt='category-img' />
                                        </div>
                                        <div className='contbox'>
                                            <p className='catname'>{data.catname}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>

                    {/* Toggle View More/View Less button */}
                    {/* <div className="view-more-btn-wrapper" style={{ textAlign: 'center', marginTop: '30px' }}>
                        <button
                            className="view-more-btn"
                            onClick={() => setShowAll(!showAll)}
                        >
                            {showAll ? 'View Less' : 'View More'}
                        </button>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Categories;